import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {DisplayService} from "./display.service";
import { RememberDeviceService } from './remember-device.service';

/**
 * Interacts with YMA for RSA AA and SecruID authentication
 */
@Injectable({
  providedIn: 'root'
})
export class YmaService {

  constructor(
    private readonly http: HttpClient,
    private readonly displayService: DisplayService,
    private readonly rdService: RememberDeviceService
  ) { }

  public onSecurIDLogin(code) {

    const operationalContext = [];
    operationalContext.push({key: "spi.auth.factor.flowid", value: "securid"})

    const credData = [];
    credData.push({key: "code", value: code})

    const postData = {
      operationalContext: operationalContext,
      credData: credData,
      deviceTag: true
    };
    this.rdService.checkAndApply(postData);
    return this.http.post(this.displayService.proxyUrl + 'factor/v1/CustomAuthenticator', postData);
  }

}
